import { Component, OnInit, EventEmitter, Output, Input } from "@angular/core";
import { Resource } from "src/app/core/coreResource";
import { PaymentService } from "../shared/services/payment.service";
import { PaymentDetails } from "../shared/models/paymentdetails";
import { PaymentRequest } from "../shared/models/makepaymentReq";
import { Router } from "@angular/router";
declare var PaymentSession: any;
declare var ThreeDS: any;

@Component({
    selector: "app-mpgs",
    templateUrl: "./mpgs.component.html",
    styleUrls: ["./mpgs.component.css"],
    standalone: false
})
export class MPGSComponent implements OnInit {
  val;
  sessionId: string;
  sessionVersion: string;
  merchantId = "323GA1120001";
  apiPassword: string;
  paymentSession: any;
  orderCurrency: string;
  isCardNameProvided: boolean = true;
  isCardNumberProvided: boolean = true;
  isExpiryYearProvided: boolean = true;
  isExpiryMonthProvided: boolean = true;
  isSecurityCodeProvided: boolean = true;
  isSecurityCodeValid: boolean = true;
  isMasterCard: boolean = true;
  auth: boolean = false;
  amount: string;
  callBackValue: any;
  isLoading: boolean = false;
  //val's addition
  payWithMPGS: boolean = true;
  @Input() paymentDetails: PaymentDetails;
  @Output() isMakingPayment = new EventEmitter();
  cardpaymentreq = new PaymentRequest();

  constructor(
    private payservice: PaymentService,
    private coreresource: Resource,
    private route: Router
  ) {}

  ngOnInit() {
    this.setPaymentDetails(this.paymentDetails);
    this.callBackValue = null;
  }

  setPaymentDetails(details) {
    this.cardpaymentreq.reference = details.referenceId;
    this.cardpaymentreq.clientId = details.clientId;
    this.cardpaymentreq.userId = details.userId;
    this.cardpaymentreq.paymentUrl = details.paymentUrl;
    this.cardpaymentreq.amount = details.amount;
    this.cardpaymentreq.currency = details.currency;
    this.cardpaymentreq.callbackUrl = details.notificationUrl;
    this.cardpaymentreq.paymentChannel = "CARD";
    sessionStorage.setItem("orderId", `ord_${this.paymentDetails.referenceId}`);
    sessionStorage.setItem(
      "paymentDetails",
      JSON.stringify(this.cardpaymentreq)
    );
    this.createSession();
  }

  createSession() {
    this.payservice.createSession().subscribe(
      async (response) => {
        this.sessionId = await response["session"].id;
        // this.payservice.sessionId = await response.session.id; //assingning the session to vairable in payment service
        sessionStorage.setItem("sessionId", this.sessionId);
        this.sessionVersion = "59";

        this.updateSession();
        // this.initializeThreeDS();
        this.setDoms();
        this.initializeThreeDS();
      },
      (err) => {}
    );
  }

  updateSession() {
    const requestBody = {
      sessionId: this.sessionId,
      order: {
        id: `ord_${this.paymentDetails.referenceId}`,
        amount: this.cardpaymentreq.amount,
        currency: this.cardpaymentreq.currency,
      },
      transaction: {
        id: this.paymentDetails.referenceId,
      },
      authentication: {
        channel: "PAYER_BROWSER",
        purpose: "PAYMENT_TRANSACTION",
        acceptVersions: "3DS1, 3DS2",
        // redirectResponseUrl: `http://localhost.com/mpgs/${this.paymentDetails.referenceId}`, //put a valid later challenge Preference: "NO_CHALLENGE",
        redirectResponseUrl: `${this.coreresource.redirectUrlForMpgs}/mpgs/${this.paymentDetails.referenceId}`, //put a valid later challenge Preference: "NO_CHALLENGE",
        transactionId: this.paymentDetails.referenceId,
      },
    };
    this.payservice.updateSession(requestBody).subscribe(
      (response) => {
        this.setDoms();
        this.initializeThreeDS();
      },
      (err) => {}
    );
  }

  setDoms() {
    let _instance = this; //you are refereing to the instance of the object
    PaymentSession.configure({
      session: this.sessionId,
      fields: {
        // ATTACH HOSTED FIELDS TO YOUR PAYMENT PAGE FOR A CREDIT CARD

        card: {
          number: "#card-number",
          securityCode: "#security-code",
          expiryMonth: "#expiry-month",
          expiryYear: "#expiry-year",
          nameOnCard: "#cardholder-name",
        },
      },
      //SPECIFY YOUR MITIGATION OPTION HERE
      frameEmbeddingMitigation: ["javascript"],
      callbacks: {
        initialized: (response) => {
          // HANDLE INITIALIZATION RESPONSE
        },
        formSessionUpdate: async (response) => {
          // HANDLE RESPONSE FOR UPDATE SESSION
          if (response.status) {
            if ("ok" == response.status) {
              // this.paymentTransaction(response.session.id);

              // this.sessionId = response.session.id;
              let _rexp = response.sourceOfFunds.provided.card;
              //check if the security code was provided by the user
              if (response.sourceOfFunds.provided.card.securityCode) {
              } else {
                this.isSecurityCodeProvided = false;
              }

              if (response.sourceOfFunds.provided.card.nameOnCard) {
              } else {
                this.isCardNameProvided = false;
              }

              //check if the user entered a Mastercard credit card
              if (response.sourceOfFunds.provided.card.scheme == "MASTERCARD") {
              } else {
                this.isMasterCard = false;
              }
              if (_rexp.securityCode && _rexp.nameOnCard && _rexp.scheme) {
                await _instance.RegisterPaymentDetails();
                //this is where we make our payment .. val
                _instance.sessionId = response.session.id;
                _instance.initiateAuthentication();
                _instance.isLoading = false;

                return;
              }

              // this.retrieveSession(response.session.id);
            } else if ("fields_in_error" == response.status) {
              if (response.errors.cardNumber) {
                this.isCardNumberProvided = false;
              } else {
                this.isCardNumberProvided = true;
              }
              if (response.errors.expiryYear) {
                this.isExpiryYearProvided = false;
              } else {
                this.isExpiryYearProvided = true;
              }
              if (response.errors.expiryMonth) {
                this.isExpiryMonthProvided = false;
              } else {
                this.isExpiryMonthProvided = true;
              }
              if (response.errors.securityCode) {
                this.isSecurityCodeValid = false;
              } else {
                this.isSecurityCodeValid = true;
              }
            } else if ("request_timeout" == response.status) {
            } else if ("system_error" == response.status) {
            }
          } else {
          }
          // There is no need for this anymore......
          if (
            this.isCardNameProvided === true &&
            this.isCardNumberProvided === true &&
            this.isExpiryMonthProvided === true &&
            this.isExpiryYearProvided === true &&
            this.isSecurityCodeProvided === true &&
            this.isSecurityCodeValid === true &&
            this.isMasterCard === true
          ) {
            // this.retrieveSession(this.sessionId);
            // this.initiateAuthentication();
            // I have moved to line 106, I left it here because you need to stil hanfle the error. which not neccessary once you implement a generic handler for the error
          } else {
          }
        },
      },
      interaction: {
        displayControl: {
          formatCard: "EMBOSSED",
          invalidFieldCharacters: "REJECT",
        },
      },
      order: {
        amount: this.cardpaymentreq.amount,
        currency: this.cardpaymentreq.currency,
      },
    });
  }

  pay(payType) {
    PaymentSession.updateSessionFromForm(payType);
  }

  initializeThreeDS() {
    ThreeDS.configure({
      merchantId: this.merchantId,
      sessionId: this.sessionId,
      containerId: "3DSUI",
      callback: function () {
        if (ThreeDS.isConfigured()) {
        }
      },
      configuration: {
        userLanguage: "en-AU", //Optional parameter
        wsVersion: 59,
      },
    });
  }

  initiateAuthentication() {
    const optionalParams = {
      sourceOfFunds: {
        type: "CARD",
      },
      order: {
        walletProvider: "MASTERPASS_ONLINE",
      },
      session: {
        id: this.sessionId,
      },
      authentication: {
        acceptVersions: "3DS1,3DS2",
        channel: "PAYER_BROWSER",
        purpose: "PAYMENT_TRANSACTION",
      },
    };
    ThreeDS.initiateAuthentication(
      `ord_${this.paymentDetails.referenceId}`,
      this.paymentDetails.referenceId,
      (data) => {
        if (data && data.error) {
          var error = data.error;

          //Something bad happened, the error value will match what is returned by the Authentication API
        } else {
          var scriptContent = (<HTMLScriptElement>(
            document.getElementById("initiate-authentication-script")
          )).text;
          window.eval(scriptContent);

          switch (data.gatewayRecommendation) {
            case "PROCEED":
              this.authenticatePayer();
              //merchant's method
              break;
            case "DO_NOT_PROCEED":
              // displayReceipt(data);//merchant's method, you can offer the payer the option to try another payment method.

              break;
          }
        }
      },
      optionalParams
    );
  }

  authenticatePayer() {
    const optionalParams = {
      // fullScreenRedirect: "true",
      device: {
        browser: "CHROME",
        browserDetails: {
          "3DSecureChallengeWindowSize": "FULL_SCREEN",
          acceptHeaders: "application/json",
          colorDepth: 24,
          javaEnabled: true,
          language: "en-US",
          screenHeight: 640,
          screenWidth: 480,
          timeZone: 273,
        },
        ipAddress: "127.0.0.1", //give a valid ip address soon
      },
      order: {
        walletProvider: "MASTERPASS_ONLINE",
      },
      session: {
        id: this.sessionId,
      },
      apiOperation: "AUTHENTICATE_PAYER",
    };
    ThreeDS.authenticatePayer(
      `ord_${this.paymentDetails.referenceId}`,
      this.paymentDetails.referenceId,
      async (data) => {
        if (!data.error) {
          //data.response will contain all the response payload from the AUTHENTICATE_PAYER call.

          this.injectHtmlRedirectCode(data);
          // this.paymentTransaction(this.sessionId);

          // this.displayReceipt(data);
        }
      },
      optionalParams
    );
  }

  injectHtmlRedirectCode(apiResponse) {
    this.auth = true;
    document.getElementById("3DSUI").innerHTML = apiResponse.htmlRedirectCode;
    document.getElementById("redirectTo3ds1Frame").style.height = "420px";
    document.getElementById("redirectTo3ds1Frame").style.border = "none";
    document.getElementById("redirectTo3ds1Frame").style.overflow = "hidden";
    document.getElementById("redirectTo3ds1Frame").style.backgroundColor =
      "white";
    var scriptContent = (<HTMLScriptElement>(
      document.getElementById("authenticate-payer-script")
    )).text;
    window.eval(scriptContent);
  }

  //make payment endpoint
  RegisterPaymentDetails(): any {
    this.isLoading = true;
    this.cardpaymentreq["provider"] = "MASTERCARD_GH";
    this.cardpaymentreq["metadata"] = {
      orderId: `ord_${this.paymentDetails.referenceId}`,
    };
    this.payservice.makePayment(this.cardpaymentreq).subscribe(
      async (data) => {
        this.isMakingPayment.emit("mpgs");
      },
      (error) => {
        this.isLoading = false;
        this.route.navigate([
          `/failure/${this.paymentDetails.amount}/${
            this.paymentDetails.referenceId
          }/${btoa(this.paymentDetails.callbackURL)}`,
        ]);
      }
    );
    // });
  }
}
